// Casques et gilets en low-poly : le même modèle sert sur le personnage (lowbody.ts) et pour l'icône (icons.ts).
// Mètres ; Y vers le haut, Z vers l'avant. Casque : origine au centre du crâne. Gilet : origine au bas du buste, hauteur h.
import * as THREE from 'three';
import { flat } from './lowpoly';

function part(g: THREE.Group, geo: THREE.BufferGeometry, color: number, x = 0, y = 0, z = 0, rx = 0) {
  const m = new THREE.Mesh(geo, flat(color, { rough: 0.7 }));
  m.position.set(x, y, z);
  m.rotation.x = rx;
  m.castShadow = true;
  g.add(m);
  return m;
}
const dome = (r: number, sx: number, sy: number, sz: number, thetaLen = Math.PI / 2) => {
  const g = new THREE.SphereGeometry(r, 9, 5, 0, Math.PI * 2, 0, thetaLen);
  g.scale(sx, sy, sz);
  return g;
};

export function buildHelmet(id: string): THREE.Group {
  const g = new THREE.Group();
  if (id === 'h_mil') {
    // Casque de combat : coque olive posée au-dessus des yeux, qui descend sur les oreilles et la nuque,
    // rebord, support de vision nocturne
    part(g, dome(0.17, 1.04, 1.1, 1.1), 0x55603a, 0, 0.0, -0.005);
    part(g, new THREE.CylinderGeometry(0.176, 0.182, 0.03, 9), 0x434c2d, 0, -0.005, -0.005);
    for (const x of [-1, 1]) part(g, new THREE.BoxGeometry(0.03, 0.08, 0.15), 0x4d5734, x * 0.168, -0.045, -0.04);
    part(g, new THREE.BoxGeometry(0.26, 0.07, 0.03), 0x4d5734, 0, -0.04, -0.175);
    part(g, new THREE.BoxGeometry(0.06, 0.04, 0.03), 0x2a2c28, 0, 0.1, 0.18);
    for (const x of [-1, 1]) part(g, new THREE.BoxGeometry(0.02, 0.05, 0.06), 0x2a2c28, x * 0.19, 0.03, 0.01);
  } else {
    // Casque de chantier : coque jaune, nervure sur le dessus, visière avant
    part(g, dome(0.165, 1, 0.95, 1.1), 0xd9a52a, 0, 0.0, 0);
    part(g, new THREE.BoxGeometry(0.035, 0.03, 0.33), 0xe3b23a, 0, 0.148, 0);
    part(g, new THREE.BoxGeometry(0.26, 0.012, 0.07), 0xd09a22, 0, 0.0, 0.19, -0.12);
    part(g, new THREE.CylinderGeometry(0.17, 0.174, 0.018, 9), 0xc58f20, 0, -0.005, 0);
  }
  return g;
}

export function buildVest(id: string, h = 0.46): THREE.Group {
  const g = new THREE.Group();
  const base = id === 'v_mil' ? 0x4a5236 : id === 'v_police' ? 0x1f2a36 : 0x2f3d4c;
  const dark = new THREE.Color(base).multiplyScalar(0.75).getHex();
  // Corps du gilet (devant et dos), épaulières
  part(g, new THREE.BoxGeometry(0.42, h, 0.29), base, 0, h / 2, 0);
  for (const x of [-1, 1]) part(g, new THREE.BoxGeometry(0.09, 0.05, 0.27), dark, x * 0.13, h + 0.01, 0);
  part(g, new THREE.BoxGeometry(0.44, 0.06, 0.31), dark, 0, 0.04, 0); // ceinture
  if (id === 'v_police') {
    part(g, new THREE.BoxGeometry(0.4, 0.06, 0.012), 0xe8e4da, 0, h * 0.62, 0.15); // bande « POLICE »
    for (const x of [-0.1, 0.1]) part(g, new THREE.BoxGeometry(0.09, 0.1, 0.05), dark, x, h * 0.3, 0.165);
  } else if (id === 'v_mil') {
    // Porte-plaques : trois porte-chargeurs, poches latérales, col
    for (const x of [-0.12, 0, 0.12]) part(g, new THREE.BoxGeometry(0.09, 0.14, 0.06), 0x3e4530, x, h * 0.28, 0.17);
    for (const x of [-1, 1]) part(g, new THREE.BoxGeometry(0.06, 0.12, 0.14), 0x3e4530, x * 0.24, h * 0.3, 0.02);
    part(g, new THREE.BoxGeometry(0.2, 0.05, 0.12), dark, 0, h * 0.62, 0.15);
  }
  return g;
}
